import {_Books as Books} from "./_Books";
import {_Dashboard as Dashboard} from "./_Dashboard";
import {_WaitingList as WaitingList} from "./_WaitingList";

export const ModuloGruppiAPI = {
    Books: Books,
    Dashboard: Dashboard,
    WaitingList: WaitingList,
};